export const toggleArrayElement = <T extends any[]>(arrayList: T, arrayValue: string): T =>
  arrayList.includes(arrayValue)
    ? arrayList.filter(el => el !== arrayValue) as T
    : [...arrayList, arrayValue] as T;
